<div
  class="label-chip"
  [ngClass]="'label-chip--' + classMap[value] + (shipment?.delayedAction || shipment?.wccIntegrationStatus ? ' label-chip--extra-margin' : '')"
  *ngIf="shipment"
>
  <div
    *ngIf="shipment?.driverAssignCount > 1"
    class="label-chip-suffix"
    [ngClass]="'label-chip-suffix--' + classMap[value] + (shipment?.delayedAction || shipment?.wccIntegrationStatus ? ' label-chip--extra-margin' : '')"
    [matTooltip]="'shipments.ReassignedCount' | translate"
    [matTooltipPosition]="'above'"
  >
    {{shipment?.driverAssignCount}}
  </div>
  {{ statusTranslationKey + "." + value | translate }}

  <small class="label bg-warn" *ngIf="shipment?.delayedAction">{{(statusTranslationKey + '.Delayed') | translate}}</small>
</div>
